export const getTourSubnav = (projectId: string, tourId: string) => {

  return [
    {
      title: 'Tour Stops',
      to: `/project/${projectId}/tour/${tourId}`
    },
    {
      title: 'Tour Details',
      to: `/project/${projectId}/tour/${tourId}/tour-details`
    },
    {
      title: 'Translations',
      to: `/project/${projectId}/tour/${tourId}/translations`
    }
  ]
}
